import {
  TaskSearchStatus,
  searchTaskCounts as SEARCH_TASK_COUNTS,
} from '@admiin-com/ds-graphql';
import { gql } from '@apollo/client';

import { useQuery } from '@apollo/client';

export const useTaskCounts = ({
  firmId,
  entityId,
  contactId,
  createdBy,
  status,
  dueAtStart,
  dueAtEnd,
  searchName,
  skipCondition,
}: {
  firmId?: string | null;
  entityId?: string;
  contactId?: string;
  createdBy?: string;
  status?: TaskSearchStatus | 'ALL' | null;
  dueAtStart?: string | null;
  dueAtEnd?: string | null;
  searchName?: string;
  skipCondition?: boolean;
}) => {
  const { data, ...rest } = useQuery(gql(SEARCH_TASK_COUNTS), {
    variables: {
      firmId,
      entityId,
      contactId,
      createdBy,
      status: status === 'ALL' ? null : status, // Convert 'ALL' to null only when querying
      dueAtStart,
      dueAtEnd,
      searchName,
    },
    skip: skipCondition || (!firmId && !entityId && !contactId),
  });

  return {
    ...rest,
    counts: data?.searchTaskCounts,
  };
};
